module.exports = __webpack_public_path__ + "img/home.f35bb66f.svg";